RivalIQ.apps.Discovery.module('views', function (views, App, Backbone, Marionette, $, _) {
    'use strict';

    views.ChannelWall = RivalIQ.channels.views.ChannelWall.mixin({
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        ui: {
            information: '.connect-reason'
        },

        template: '#discoveryAuthWallTemplate',
        size: 'large',

        loadData: function () {
            const me = this;

            me.searchRecommendationsGenerator = new App.data.SearchRecommendationsGenerator({
                dashboardModel: me.dashboardModel
            });

            const deferred = new $.Deferred();
            me.searchRecommendationsGenerator
                .loadData()
                .always(deferred.resolve);

            return deferred;
        },

        onRenderLoaded: function () {
            const me = this;

            me.ui.information.popover();
        },

        serializeData: function () {
            const me = this;

            const data = RivalIQ.channels.views.ChannelWall.prototype.serializeData.call(me);
            const displaySourceDetails = RivalIQ.enums.sourceDetails[me.displaySource];
            data.buttonName = data.name;
            const descriptionReasonChannelName = data.name;
            data.name = (displaySourceDetails ? displaySourceDetails.name : data.name);

            const recommendations = me.searchRecommendationsGenerator.getRecommendations();

            let description = ['Connect your', data.name, 'account to explore influencers around'];
            if (recommendations.length > 0) {

                const topRecommendations = _.map(recommendations.take(2), function (recommendation) {
                    if (recommendation.get('type') === 'top-hashtag') {
                        return RivalIQ.str('discovery_recommendation_hashtag_auth_wall', recommendation.get('value'));
                    } else if (recommendation.get('type') === 'top-mentioned') {
                        return RivalIQ.str('discovery_recommendation_competitor_content_auth_wall', recommendation.get('value'));
                    } else {
                        return RivalIQ.str('discovery_recommendation_my_content_auth_wall');
                    }
                });

                description = description.concat(topRecommendations.join(', '));
                if (topRecommendations.length > 1) {
                    const lastIdx = description.length - 1;
                    description[lastIdx] = `${description[lastIdx]},`;
                }
            } else {
                description = description.concat('top hashtags');
            }
            description.push('and more.');

            data.description = description.join(' ');
            data.descriptionReason = RivalIQ.str('discovery_auth_wall_token_reason', descriptionReasonChannelName, descriptionReasonChannelName);

            if (displaySourceDetails) {
                _.extend(data, {
                    channelWallImage: displaySourceDetails.channelWallImage
                });
            }

            return data;
        }
    });
});
